import TextArea from 'antd/es/input/TextArea'
import React, { useState } from 'react'

const ViewSupport = ({showViewModal , setShowViewModal , action, setAction , selectedStaff}) => {
const [open, setOpen] = useState(showViewModal)

const closeViewModal = () => {
    setOpen(false)
    setShowViewModal(false)
}
  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50">
        <div className="bg-white  rounded-lg shadow-lg w-[700px] h-[600px] overflow-y-auto scrollbar-hidden">
          <h3 className="text-xl font-bold mb-2 text-center bg-blue-950 py-2 text-white">View Support Staff</h3>
          <form className="p-8">

          <div className="flex gap-2 ">
              <div className='w-full'>
                <label className="block mb-1">First Name</label>
                  <input
                    type="text"
                    name="name"
                    className="border border-gray-800 p-2 w-full"

                    value={selectedStaff.firstName}
                    disabled
                  />

              </div>

              <div className='w-full'>
                <label className="block mb-1">Last Name</label>
                <input
                  type="text"
                  name="lastName"
                  className="border border-gray-800 p-2 w-full"

                  value={selectedStaff.lastName}
                  disabled
                />

              </div>
            </div>

            <div className='w-full mt-2'>
                <label className="block mb-1">Email</label>
                  <input
                    type="text"
                    name="name"
                    className="border border-gray-800 p-2 w-full"

                    value={selectedStaff.email}
                    disabled
                  />

              </div>

<div className='flex gap-2'>
              <div className='w-full mt-2'>
                <label className="block mb-1">Company Name</label>
                  <input
                    type="text"
                    name="name"
                    className="border border-gray-800 p-2 w-full"

                    value={selectedStaff.companyName}
                    disabled
                  />

              </div>

              <div className='w-full mt-2'>
                <label className="block mb-1">Status</label>
                  <input
                    type="text"
                    name="name"
                    className="border border-gray-800 p-2 w-full"

                    value={selectedStaff.active ? 'Active' : 'Inactive'}
                    disabled
                  />

              </div>
              </div>


              <div className='flex gap-2'>
              <div className='w-full mt-2'>
                <label className="block mb-1">Subscription Start Date</label>
                  <input
                    type="text"
                    name="name"
                    className="border border-gray-800 p-2 w-full"

                    value={selectedStaff.startSubscription}
                    disabled
                  />

              </div>

              <div className='w-full mt-2'>
                <label className="block mb-1">Subscription End Date</label>
                  <input
                    type="text"
                    name="name"
                    className="border border-gray-800 p-2 w-full"

                    value={selectedStaff.endSubscription}
                    disabled
                  />

              </div>
              </div>


              <div className='w-full mt-2'>
                <label className="block mb-1">Address</label>
                  <textarea
                    rows={2}
                    type="text"
                    name="name"
                    className="border border-gray-800 p-2 w-full"

                    value={selectedStaff.address}
                    disabled
                  />

              </div>

          <div className="flex justify-end gap-6 mt-6">
              <button onClick={closeViewModal} className="bg-blue-500 text-black w-52 py-2 px-4 rounded-md hover:bg-gray-400 transition duration-200">
                Ok
              </button>
              {/* <button type="submit" className="bg-blue-500 text-white py-2 px-4 rounded-md w-52 hover:bg-blue-600 transition duration-200 mr-2">
                Create
              </button> */}

            </div>
          </form>
          </div>
          </div>
  )
}

export default ViewSupport